// import { FontLoader } from 'qunar-react-native';
// FontLoader.loadFontSet(require('../../assets/QFontSet.js'));
// setBizStartTime 尽可能前置
import {
    setOrderMainHasLoaded,
    getOrderMainHasLoaded,
    __biz_start_time__,
    setBizStartTime
} from '../../Utils/flagUtil';
setBizStartTime(Date.now());
import React, { Component } from 'react';
import { View, StyleSheet, NativeModules, AppState, Platform } from 'react-native';
import { StatusBar as QRNStatusBar, AppInfo, DeviceInfo, QSendNotification, NativeNavigator } from 'qunar-react-native';
import { Provider, observer } from 'mobx-react/native';
// import rootStore from './Store/index';
import RootStore from '../../Store/index';
import FilterBar from '../../Views/FilterBar';
import StatusBar from '../../Views/StatusBar';
import GuideWeChat from '../../Views/GuideWeChat';
import LoginBar from '../../Views/LoginBar';
import OrderList from '../../Views/OrderList/index';
import BindNotice from '../../Views/BindNotice';
import BindAlert from '../../Views/BindAlert';
import HasShareAlert from '../../Views/HasShareAlert';
import PerfQav from '../../Utils/perfQav';
// import { PerQavManager } from '../../Utils/PerQavManager';
import * as loginUtil from '../../Utils/loginUtil';
// import { LoginManager } from '../../Utils/LoginManager';
import { getStatusDataById } from '../../Constant/statusBarData';
import { getInfoById } from '../../Constant/filterBarData';
// import QImageSet from '../../../../src/assets/QImageSet'
import QImageSet from '../../assets/QImageSet';
import { toast } from '../../Utils/toast';
import PPLogUtil, { OPER_SHOW } from '../../Utils/PPLogUtil';
import {PopViewType} from '../../Utils/PopViewManager'
import { Colors } from '@qnpm/q-theme';
import MoreButtonList from "../MoreButtonList/index";
import getBusinessTypeFromUrl from '../../Utils/getBusinessTypeFromUrl';
import checkOrderListByHash from '../../Utils/checkOrderListByHash'
import {navigate} from "../../Utils/navigate";
import props from '../../../../order-three/packages/.unir-pack-env/wechat/order_rn/dist/wechat/pages/order_rn/list/index';
import QSlugger from '../Slugger/qSlugger';
const { QnrShakeDetectorUtil, HomeTabIndexManager } = NativeModules || {};
const { isWeb } = DeviceInfo;
const BROADCAST_SHAKE_TRIP_TAB = 'pp-shake-tripTab';// 位于底部TAB时双TAB的广播名
const BROADCAST_SHAKE_TRIP_SUB = 'pp-shake-tripSub';// 位于二级页面双TAB时的广播名
const BROADCAST_SHAKE_ORDER = 'pp-shake-order';// 位于订单独立页面的广播名
const HOME_TAB_INDEX_ORDER = 1;// 底部TAB订单索引

const { scenes:{ baseColor } } = Colors;
// global.$orderMainHasLoaded = false;
setOrderMainHasLoaded(false);

interface OrderMainViewInterface {
    source?: string;
    statusFilter?: string;
    filterBusiness?: boolean;
    businessType?: string;
    tapTime?: number;
    tips?: string;
    searchType?:number;
    searchKey?:string;
    searchTagKey?:string;
    searchBusinessValue?:string;
    searchOrderStatus?:string;


    filterBarBgColor?: string;
    filterBarBgCorner?: number;
    filterBarItemSelectedBgColor?: string;
    filterBarItemSelectedTitleColor?: string;
    filterBarItemUnSelctedBgColor?: string;
    filterBarItemUnSelctedTitleColor?: string;

    tabsPaddingHorizontal?: number;
    tabBgColor?: string;
    tabItemSelectedBgColor?: string;
    tabItemSelectedTitleColor?: string;
    tabItemUnSelctedBgColor?: string;
    tabItemUnSelctedTitleColor?: string;
    isJourneyInnerModule?: boolean; // 是否为行程内部模块
    currentSelectedIndex?: number;

    selecteFilterItemCallBack?: (
        filterInfo: { [propName: string]: string },
        index: number,
        isJump: boolean
    ) => void;
    clickFilterBlankAreaCallBack?: () => void;
    loginOutCallBack?: () => void;
    loginInCallBack?: () => void;
    onLoginSuccessCallBack?:() => void;
}
interface OrderMainViewMethod {
    handleActived(): void;
    handleDeactived(): void;
    // checkLoginState(): void;
    showFilterBar(): void;
    hideFilterBar(): void;
    getCurrentTitle(): void;
    refreshData(): void;
    showLogin(): void;
    changeTab(tabId: string, failCallBack: () => void): void;
    changeTabForAll(tabId: string, successCallBack: () => void): void;
    updateCurrentSelectedIndex(index: number): void;
    checkPopView(): void;
    isShowingPopView(): boolean;
    clearAllMemoryPopView(): void;
    updateIsInCurrentPage(isInCurrentPage: boolean): void;
    refreshWithNoLoadingView(): void;
    orderEveryShow(): void;
    orderEveryHide(): void;
    isBackFromOrderDetail(): boolean;
    updateIsBackFromOrderDetail(isBackFromOrderDetail:boolean): void;
    requestUpdateOrderItem(): void;

}

// init: store.orderlist.init,
@observer
class OrderMainView extends Component<OrderMainViewInterface> implements OrderMainViewMethod {
    // public rootStore = new RootStore();
    public rootStore: RootStore;
    public shakeDetectorListener: any;
    public isPrivateDialogShowing: boolean;// 当前弹窗是否有显示
    public lastAppState: string;

    public constructor(props: OrderMainViewInterface) {
        super(props);
        // 前端路由
        if(isWeb){
            if(!checkOrderListByHash()){
                return;
            }
        }
        this.rootStore = new RootStore();
        if (this.props.isJourneyInnerModule) {
            this.rootStore.hyId = 'commonbusiness_rn';
        }
        this.rootStore.uiState.isJourneyInnerModule = this.props.isJourneyInnerModule;
        this.rootStore.uiState.currentSelectedIndex = this.props.currentSelectedIndex;
        this.rootStore.uiState.isOneLevelPage = this.props.isOneLevelPage;
        this.rootStore.checkPopViewFunc = this.checkPopView;

        const {
            statusFilter = 'all',
        } = this.props;
        this.rootStore.perfQav = new PerfQav({
            businessType: 'pp',
            pageId: `order_rn_main_${statusFilter}`,
            pageType: 'rn'
        });


        let {
            source: sourceFrom = 'list',
            filterBusiness: enableFilter = true,
            businessType: businessId = 'all',
            tapTime = 0,
            tips,
            searchType=1,
            searchKey='',
            searchTagKey='',
            searchBusinessValue='',
            searchOrderStatus=''
        } = this.props;
        if(isWeb){
            businessId = getBusinessTypeFromUrl()
        }
        // 隐藏filterbar
        this.rootStore.uiState.isShowFilterBar && this.rootStore.uiState.toggleFilterBarShow(false);
        // 重置筛选功能
        this.rootStore.uiState.toggleEnableFilter(enableFilter);
        // 设置页面访问来源
        this.rootStore.uiState.setSourceFrom(sourceFrom);
        // 设置搜索数据：
        this.rootStore.uiState.setSearchType(searchType);
        this.rootStore.uiState.setSearchKey(searchKey);
        this.rootStore.uiState.setSearchTagKey(searchTagKey);
        this.rootStore.uiState.setSearchBusinessValue(searchBusinessValue);
        this.rootStore.uiState.setSearchOrderStatus(searchOrderStatus);

        // 重置状态栏
        this.rootStore.changeStatus(statusFilter, businessId);
        // 提示去登录的白条，重置
        this.rootStore.uiState.toggleShowLoginBar(false);
        // 有未绑定订单的小黄条，重置
        this.rootStore.bindNotice.toggleShowBindNotice(false);
        // 有未绑定订单的弹窗，重置
        this.rootStore.bindNotice.toggleUnbindAlert(false);
        // 有共享单的弹窗，重置
        this.rootStore.hasShare.hideHasShareAlert();

        const isCold = getOrderMainHasLoaded();
        setOrderMainHasLoaded(true);

        const isFirstLoad = true;

        this.rootStore.perfQav.setIsCold(isCold ? 2 : 1);
        this.rootStore.perfQav.setClickTime(tapTime);
        this.rootStore.perfQav.setBizStart(__biz_start_time__);
        this.rootStore.perfQav.setOnshow(Date.now());

        this.rootStore.resetPage(businessId, isCold, isFirstLoad);

    }

    /**
     * 返回页面时调用的方法
     * 首页双TAB时
     * ADR&iOS 从二级页面返回时不会调用
     *
     * 我的页面进入双TAB时
     * ADR&iOS 从二级页面返回会调用
     *
     * 单独的订单时
     * ADR&iOS 从二级页面返回会调用
     */
    public async handleActived() {
        this.rootStore.actived = true;
        // 跳走之前就知道回来要刷新
        if (this.rootStore.needRefresh) {
            this.rootStore.needRefresh = false;
            this.rootStore.resetPage();
        }
        // 如果是从登录页回来的，要重置相关参数
        // if (global.isLogining) {
        //     global.isLogining = false;
        //     global.$goLoginTimer && clearTimeout(global.$goLoginTimer);
        //     global.$goLoginTimer = null;
        // }
        if (this.rootStore.loginManager.isLogining) {
            this.rootStore.loginManager.isLogining = false;
            this.rootStore.loginManager.goLoginTimer &&
                clearTimeout(this.rootStore.loginManager.goLoginTimer);
            this.rootStore.loginManager.goLoginTimer = null;
        }

        // 还有一种情况，即为登录情况下跳订单，在订单页面触发了登录，回来要校验登录态
        if (this.rootStore.needCompareLogin) {
            this.rootStore.needCompareLogin = false;
            const nowIsLogin = await loginUtil.isLogin();
            if (this.rootStore.uiState.isLogin !== nowIsLogin) {
                this.rootStore.resetPage();
            }
        }
        this.orderEveryShow();
    }

    /**
     * 离开页面时调用的方法
      */
    public handleDeactived() {
        this.rootStore.actived = false;
        this.orderEveryHide();
    }

    //刷新(不显示加载图)
    public refreshWithNoLoadingView(){
        // this.rootStore.orderlist && this.rootStore.orderlist.init && this.rootStore.orderlist.init('refresh')
        this.rootStore.orderlist && this.rootStore.orderlist.init && this.rootStore.orderlist.init('backgroundRefresh')
        // this.rootStore.resetPage();
        this.rootStore.changeStatus(this.rootStore.uiState.statusFilter || '',this.rootStore.uiState.businessId || '');
    }

    // 刷新数据
    public refreshData() {
        this.rootStore.orderlist.showNoData = false;
        this.changeTabForAll('all', () => {});
    }

    // 未登录展示登录
    public showLogin() {
        this.rootStore.orderlist.showNoData = true;
        this.rootStore.orderlist.showNoDataView({
            isLogin: false,
            type: "noLoginAndNoLocalOrder"
        });
    }
    // 显示筛选框
    public showFilterBar() {
        this.rootStore.uiState.enableFilter && this.rootStore.uiState.toggleFilterBarShow(true);
    }

    // 隐藏筛选框
    public hideFilterBar() {
        this.rootStore.uiState.toggleFilterBarShow(false);
    }

    // 获取顶部标题
    public getCurrentTitle() {
        return this.rootStore.uiState.filterBarTitle;
    }
    // 切换 tab，并滚动到顶部,如果筛选选项下没有对应的tab，则筛选选项直接切换到全部
    public changeTab(tabId: string, failCallBack: () => void) {
        let statusData = getStatusDataById(this.rootStore.uiState.businessId, tabId);
        let id = tabId;
        if (!statusData) {
            if (failCallBack) {
                failCallBack();
            }
            statusData = getStatusDataById('all', 'all');
            id = 'all';
            this.rootStore.uiState.businessId = 'all';
        }
        this.rootStore.changeStatus(id);
        this.rootStore.orderlist.scrollTopAndInit();
    }

    // 全部订单模式下，切换tab，并滚动到顶部
    public changeTabForAll(tabId: string, successCallBack: () => void) {
        let statusData = getStatusDataById('all', tabId);
        if (statusData) {
            if (successCallBack) {
                successCallBack();
            }
            // this.rootStore.uiState.statusFilter = tabId;//此行代码导致错误
            this.rootStore.resetPage('all');
            // this.rootStore.orderlist.scrollTopAndInit()
            this.rootStore.changeStatus('all');
        }
    }

    // 如果为行程内置模块，同步行程当前tab选中的下标
    public updateCurrentSelectedIndex(index:number = 0){
        this.rootStore.uiState.currentSelectedIndex = index;
    }

    // 更新是否在当前页面标记
    public updateIsInCurrentPage(isInCurrentPage:boolean ){
        this.rootStore.uiState.isInCurrentPage = isInCurrentPage;
    }

    // 检测本地弹框
    checkPopView = () => {
        if(!this.rootStore.uiState.isInCurrentPage){
            return
        }
        if(!this.rootStore.uiState.isJourneyInnerModule){
            return
        }
        if(this.rootStore.uiState.currentSelectedIndex !== 1){
            return
        }
        if(this.rootStore.hasShare.hasShareAlertVisiable){
            return
        }
        let popViewType  = this.rootStore.popViewManager.checkMemoryPopView()
        if(popViewType){
            switch (popViewType) {
                case PopViewType.popViewTypeBindAlert:
                    //1、校验数据合法性
                    //2、显示
                    this.rootStore.bindNotice.toggleUnbindAlert(true);
                  break

                case PopViewType.popViewTypeHasShareAlert:

                  break
                default:
                  break;
              }
        }
    }

    // 是否正在展示弹框
    public isShowingPopView(){
        if(this.rootStore.popViewManager.isShowingPopView()){
            return true
        }
        if(this.rootStore.hasShare.hasShareAlertVisiable){
           return true;
        }
        return false
    }

    public clearAllMemoryPopView(){
        this.rootStore.popViewManager.clearAllMemoryPopView()
    }

    test(){
        // this.rootStore.popViewManager.addPopView(PopViewType.popViewTypeBindAlert)
        // this.rootStore.hasShare.hasShareAlertVisiable = true
        // this.rootStore.hasShare.hasShareAlertTitle = "hello"
        setTimeout(() => {
            // this.rootStore.popViewManager.addPopView(PopViewType.popViewTypeBindAlert)
            // this.checkPopView()
            this.rootStore.popViewManager.addPopView(PopViewType.popViewTypeBindAlert)
            this.rootStore.popViewManager.addPopView(PopViewType.popViewTypeBindAlert)
            this.rootStore.popViewManager.addPopView(PopViewType.popViewTypeBindAlert)
            // if(this.rootStore.uiState.currentSelectedIndex === 1 && !this.rootStore.popViewManager.isShowingPopView()
            // && this.rootStore.bindNotice.showBindNotice === false){
                this.rootStore.checkPopViewFunc && this.rootStore.checkPopViewFunc()
            // }
        }, 2000);
        // this.rootStore.bindNotice.unbindAlertVisiable = true
    }

    public async orderEveryShow() {
        const isLogin = Boolean(await loginUtil.isLogin());
        const businessInfo = getInfoById(this.rootStore.uiState.businessId);
        const { title: businessName } = businessInfo;
        PPLogUtil.orderListEnterLog(
            businessName,
            isLogin ? '1' : '0',
            this.rootStore.uiState.sourceFrom
        );

        PPLogUtil.logForKeyWatcher({operType: OPER_SHOW, id: 'orderPage'});
    
        if (AppInfo.isTouristMode) {
            // 支持游客模式判断
            AppInfo.isTouristMode((callBack: any) => {
                // 用户处于非游客模式下，才注册
                !callBack.isTouristMode && this.registerShakeDetector();
            });
        } else {
            // 不支持游客模式，直接注册
            this.registerShakeDetector();
        }
        // console.log('#################orderEveryShow');
    }
    
    public registerShakeDetector(){
        if(!DeviceInfo.isNotRn && QnrShakeDetectorUtil && QnrShakeDetectorUtil.registerShakeDetector){
            // 添加对摇一摇的注册
            const tripBroadcastName = this.rootStore.uiState.isOneLevelPage ? BROADCAST_SHAKE_TRIP_TAB : BROADCAST_SHAKE_TRIP_SUB;
            QnrShakeDetectorUtil.registerShakeDetector(this.rootStore.hyId, this.rootStore.uiState.isJourneyInnerModule ? tripBroadcastName : BROADCAST_SHAKE_ORDER);
        }
    }

    public async orderEveryHide(){
        if(!DeviceInfo.isNotRn && QnrShakeDetectorUtil && QnrShakeDetectorUtil.unregisterShakeDetector){
            // 取消对摇一摇的注册
            const tripBroadcastName = this.rootStore.uiState.isOneLevelPage ? BROADCAST_SHAKE_TRIP_TAB : BROADCAST_SHAKE_TRIP_SUB;
            QnrShakeDetectorUtil.unregisterShakeDetector(this.rootStore.hyId, this.rootStore.uiState.isJourneyInnerModule ? tripBroadcastName : BROADCAST_SHAKE_ORDER);
        }
        // console.log('#################orderEveryHide');

        // 页面切走后,隐藏掉所有隐私订单
        this.rootStore.orderlist.hidePrivacyOrder();

    }

    public isBackFromOrderDetail(){
        return this.rootStore.uiState.isBackFromOrderDetail;
    }
    public updateIsBackFromOrderDetail(isBackFromOrderDetail = false){
        this.rootStore.uiState.isBackFromOrderDetail = isBackFromOrderDetail
    }
    public requestUpdateOrderItem(){
        this.rootStore.orderlist.requestUpdateOrderItem()
    }

    // 可以理解为从一个页面主动唤起订单页面，都会走componentWillMount
    public async componentDidMount() {
        // global.$perfQav.setDidLoad(Date.now());
        QRNStatusBar.setStyle(
            'dark',
            () => { },
            () => { }
        );
        this.rootStore.perfQav.setDidLoad(Date.now());
        this.orderEveryShow()
        const { tips } = this.props;
        if (tips) {
            toast({ msg: tips });
        }
        if (this.props.loginOutCallBack) {
            this.rootStore.loginOutCallBack = this.props.loginOutCallBack;
        }
        if (this.props.loginInCallBack) {
            this.rootStore.loginInCallBack = this.props.loginInCallBack;
        }
        if(this.props.onloginSuccessCallBack){
            this.rootStore.onloginSuccessCallBack = this.props.onloginSuccessCallBack;
        }

        let tripBroadcastName = this.rootStore.uiState.isOneLevelPage ? BROADCAST_SHAKE_TRIP_TAB : BROADCAST_SHAKE_TRIP_SUB;
        // 添加对广播的监听
        QSendNotification.addNotification({
            name: this.rootStore.uiState.isJourneyInnerModule ? tripBroadcastName : BROADCAST_SHAKE_ORDER,
            subscriptionCallback: (subscription: any) => {
                this.shakeDetectorListener = subscription;
            },
            dataCallback: async (data: any) => {
                if (!this.rootStore.actived){
                    // 当前页面并不处于active状态，不再做处理。注意，ADR上如果从订单直接进入客服页(android:windowIsTranslucent=true)的话，是不会触发active和deactive方法的
                    return;
                }

                let shouldPop =  await this._currentVCShouldPop();
                if (!shouldPop) {
                    // 判断顶层页面，是不是首页、或者订单列表页
                    return;
                }

                let isLogin = await loginUtil.isLogin();
                const supportPrivateOrder = this.rootStore.orderlist && this.rootStore.orderlist.supportPrivateOrder;
                if (this.isPrivateDialogShowing || !this.rootStore.uiState.isInCurrentPage || !isLogin || !supportPrivateOrder){
                    // 当隐私密码弹窗正在显示时，或者当前页面未展示时，或者当前页面未登录，或者当前业务线订单页面不支持隐私订单，不再处理
                    return;
                }
                if (this.rootStore.uiState.isJourneyInnerModule && this.rootStore.uiState.currentSelectedIndex != 1){
                    // 如果当前处于订单与行程双TAB中，当前选中索引不是订单，不再处理
                    return;
                }

                const isOrderTabIndex = await this._isOrderTabIndex();
                if (this.rootStore.uiState.isJourneyInnerModule && this.rootStore.uiState.isOneLevelPage && !isOrderTabIndex){
                    // 如果当前处于订单与行程双TAB中，处于一级行程页面但当前底部TAB不是订单，不再处理
                    return;
                }

                this.isPrivateDialogShowing = true;
                if (Platform.OS === 'ios') {
                    // 对齐adr逻辑，因为ADR 弹出隐私弹窗后，会自动触发deactive方法，而iOS 不会
                    this.rootStore.orderlist.hidePrivacyOrder();
                }
                navigate(
                    {
                        isSchema: true,
                        schema: DeviceInfo.scheme + '://uc/privatePwdValidate'
                    },
                    (res: any) => {
                        this.isPrivateDialogShowing = false;
                        if (res?.data?.uc_private_pwd){
                            // 传给订单接收相应的参数
                            // alert(res?.data?.uc_private_pwd)
                            this.rootStore.orderlist.isNeedShowShakeToast = true;
                            this.rootStore.orderlist.privateOrderWord = res?.data?.uc_private_pwd;
                            this.rootStore.orderlist.scrollTopAndInit(false);
                        }
                    }
                );
                PPLogUtil.logForShakeInOrderList(this.rootStore.uiState.sourceFrom)
            },
            errorCallback: (res) => {
            }
        })

        // 监听屏幕变化，改变本地宽高尺寸
        this.rootStore.size.registryConfigrationChange();
        AppState.addEventListener('change', this._handleAppStateChange);
        // 临时测试*****
        // this.test()
    }

    _currentVCShouldPop = async () => {
        return new Promise((resolve, reject) => {
            if (!NativeNavigator || !NativeNavigator.getPageStacks) {
                resolve(true);
                return;
            }

            NativeNavigator.getPageStacks((vcStacks:any)=>{
                let topVCInfo = vcStacks[vcStacks.length - 1];
                if (!topVCInfo) {
                    resolve(true);
                    return;
                }

                if (topVCInfo.nativeName === 'HomeVC' || topVCInfo.nativeName === 'MainActivity') {
                    resolve(true);
                    return;
                }

                if (topVCInfo.hybridId === 'commonbusiness_rn' ||  topVCInfo.hybridId === 'cmn_order_rn') {
                    resolve(true);
                    return;
                }


                resolve(false);

            });


        });
    }

    _isOrderTabIndex = async() => {
        return new Promise((resolve, reject) => {
            if (!HomeTabIndexManager || !HomeTabIndexManager.getHomeTabIndex) {
                resolve(true);
                return;
            }

            HomeTabIndexManager.getHomeTabIndex((homeTabIndex: any) => {
                // console.log("homeTabIndex:" + homeTabIndex);
                resolve(homeTabIndex === HOME_TAB_INDEX_ORDER);
            })
        });;
    }

    _handleAppStateChange = (nextAppState: string) => {
        if (nextAppState === 'active' ) {
            // 从后台进前台
            // if(Platform.OS === 'ios' && this.rootStore.actived && this.rootStore.uiState.isInCurrentPage && (!this.rootStore.uiState.isJourneyInnerModule || this.rootStore.uiState.currentSelectedIndex == 1)) {
            if(Platform.OS === 'ios' && this.rootStore.uiState.isInCurrentPage && (!this.rootStore.uiState.isJourneyInnerModule || this.rootStore.uiState.currentSelectedIndex == 1)) {
                // 如果是单独的订单，当前页面展示即可。如果是订单行程双TAB这种，需要满足条件当前选中的TAB是订单
                this.orderEveryShow();
            }
        } else if (nextAppState === 'background'){
            // 从前台进后台
            // if(Platform.OS === 'ios' && this.rootStore.actived){
            if(Platform.OS === 'ios'){
                this.orderEveryHide();
            }
        }
        this.lastAppState = nextAppState;
    };
    
    public componentWillUnmount() {
        AppState.removeEventListener('change', this._handleAppStateChange);
        this.orderEveryHide();
        // rootStore.orderlist.changeDataSource({ newDataSource: [] });
        this.rootStore.orderlist.changeDataSource({ newDataSource: [], append: false });
        this.rootStore.size.unregistryConfigrationChange();
        // 取消广播的注册
        let tripBroadcastName = this.rootStore.uiState.isOneLevelPage ? BROADCAST_SHAKE_TRIP_TAB : BROADCAST_SHAKE_TRIP_SUB;
        this.shakeDetectorListener && QSendNotification.removeNotification({
            name: this.rootStore.uiState.isJourneyInnerModule ? tripBroadcastName : BROADCAST_SHAKE_ORDER,
            subscription: this.shakeDetectorListener,
            errorCallback: (res: any) => {

            }
        });
    }
    orderSearchEntry = (sourceFrom:any) => {
        return this.rootStore.orderlist.orderSearchEntry() || sourceFrom == 'mine';
    };
    public render() {
        const { source:sourceFrom } = this.props;
        const { orderSearchFlag }= this.rootStore.orderlist;
        return (
            <Provider {...this.rootStore}>
                {
                    orderSearchFlag(sourceFrom) ? (
                        <View style={[styles.rootView,{paddingTop:0}]}>
                            <OrderList/>
                            <MoreButtonList />
                        </View>
                    ) : (
                        <View style={[styles.rootView,{paddingTop:this.orderSearchEntry(sourceFrom)?90:49}]}>
                            {/* 登录条 */}
                            {this.rootStore.uiState.showLoginBar && <QSlugger target={LoginBar} />}
                            {/* 订单绑定提示条 */}
                            {this.rootStore.bindNotice.showBindNotice && <QSlugger target={BindNotice} />}
                            {/* 关联&&绑定微信提示 */}
                            {/* <GuideWeChat /> */}
                            {/* 订单列表 */}
                            <OrderList/>
                            {/* 状态栏 */}
                            <StatusBar
                                tabsPaddingHorizontal={this.props.tabsPaddingHorizontal || 12}
                                tabBgColor={this.props.tabBgColor || baseColor.background2}
                                tabItemSelectedBgColor={this.props.tabItemSelectedBgColor || baseColor.brandBorder}
                                tabItemSelectedTitleColor={
                                    this.props.tabItemSelectedTitleColor || baseColor.brandText
                                }
                                tabItemUnSelctedBgColor={this.props.tabItemUnSelctedBgColor || baseColor.background2}
                                tabItemUnSelctedTitleColor={
                                    this.props.tabItemUnSelctedTitleColor || baseColor.text2
                                }
                            />
                            {/* 业务线筛选栏 */}
                            <QSlugger
                                target={FilterBar}
                                filterBarBgColor={this.props.filterBarBgColor || baseColor.background2}
                                filterBarBgCorner={this.props.filterBarBgCorner || 0}
                                filterBarItemSelectedBgColor={this.props.filterBarItemSelectedBgColor}
                                filterBarItemSelectedTitleColor={this.props.filterBarItemSelectedTitleColor}
                                filterBarItemUnSelctedBgColor={this.props.filterBarItemUnSelctedBgColor}
                                filterBarItemUnSelctedTitleColor={
                                    this.props.filterBarItemUnSelctedTitleColor
                                }
                                selecteFilterItemCallBack={(filerInfo, index, isJump) => {
                                    this.props.selecteFilterItemCallBack &&
                                        this.props.selecteFilterItemCallBack(filerInfo, index, isJump);
                                }}
                                clickFilterBlankAreaCallBack={() => {
                                    this.props.clickFilterBlankAreaCallBack &&
                                        this.props.clickFilterBlankAreaCallBack();
                                }}
                            />
                            {/* 未绑定订单提示框 */}
                            {
                                !DeviceInfo.isMini
                                && this.rootStore.bindNotice.unbindAlertVisiable
                                &&
                                <QSlugger target={BindAlert} onClose={() => {
                                    if (this.rootStore.uiState.isJourneyInnerModule) {
                                        this.rootStore.popViewManager.removeCurrentPopView()
                                        this.checkPopView()
                                    }
                                }} />
                            }
                            {/* 有分享订单提示框 */}
                            {
                                !DeviceInfo.isMini
                                && this.rootStore.hasShare.hasShareAlertVisiable
                                &&
                                <QSlugger target={HasShareAlert} onClose={() => {
                                    if (this.rootStore.uiState.isJourneyInnerModule) {
                                        this.checkPopView()
                                    }
                                }} />
                            }
                            {
                                !DeviceInfo.isMini
                                && this.rootStore.moreButtonStore.show
                                &&
                                <QSlugger target={MoreButtonList} />
                            }
                        </View>
                    )
                }
            </Provider>
        );
    }
}

export default OrderMainView;

let styles = StyleSheet.create({
    rootView: {
        flex: 1,
        paddingTop: 49,
        backgroundColor: baseColor.background2
    }
});
